import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Table, Button, Input, Card, Badge } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomModal from '../../../tools/components/CustomModal';
import axios from 'axios';

// Add hover effect styles
const styles = `
    .hover-row:hover {
        background-color: rgba(0, 0, 0, 0.075) !important;
    }
`;

class AlertsNotificationsModal extends Component {
    constructor() {
        super();

        this.state = {
            isTheModalOpen: false,
            alertsList: [],
            loading: false,
            error: null,
            selectedAlert: null,
            editedEmails: '',
            newEmail: ''
        };
    }

    componentDidMount() {
        // Make the modalToggle method available to the parent component
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }
    
    // Fetch alerts data when the modal is opened
    fetchResourcesData = () => {
        this.setState({ loading: true, error: null });
        
        axios.get(process.env.REACT_APP_ALERTS_API + '/resources')
            .then(response => {
                const formattedAlerts = this.formatAlerts(response.data);
                this.setState({ 
                    alertsList: formattedAlerts,
                    loading: false 
                });
            })
            .catch(error => {
                console.error('Error fetching alerts data:', error);
                this.setState({ 
                    error: 'Error al cargar las alertas configuradas',
                    loading: false,
                    alertsList: [] // No fallback data, just show empty list on error
                });
            });
    }
    
    // Format the API response to match the component's expected data structure
    formatAlerts = (data) => {
        if (!Array.isArray(data)) {
            console.error('Expected array data but got:', data);
            return [];
        }
        
        const sourceNamePattern = this.props.downloadSource?.name?.toLowerCase() || '';
        console.log('Filtering alerts for source pattern:', sourceNamePattern);
        
        if (!sourceNamePattern) {
            console.warn('No source name available for filtering alerts');
            return [];
        }
        
        // Filter alerts based on the downloadSource name
        const filteredData = data.filter(item => {
            // Normalize the ID to lowercase for case-insensitive matching
            const id = (item.id || '').toLowerCase();
            
            // Check if the ID matches the pattern for this source
            // contentdiff-<name>, contentdiff-<name>-politicas, or scalediff-<name>
            return (
                id.includes(`contentdiff-${sourceNamePattern}`) || 
                id.includes(`scalediff-${sourceNamePattern}`)
            );
        });
        
        console.log('Filtered alerts:', filteredData.length, 'out of', data.length);
        
        return filteredData.map(item => {
            // Determine alert type based on ID pattern
            let type = 'Actualización de Información';
            if (item.id?.includes('contentdiff-') && item.id?.includes('-politicas')) {
                type = 'Actualización de Políticas';
            } else if (item.id?.includes('contentdiff-') && !item.id?.includes('-politicas')) {
                type = 'Actualización de TyC';
            } else if (item.id?.includes('scalediff-')) {
                type = 'Actualización de Escala de Valores';
            }
            
            // Extract URL if present
            const url = item.source?.url || '';
            
            // Extract recipients and join to string
            // Note: notifications is at the top level, not inside source
            const recipients = item.notifications?.recipients || [];
            const notifyTo = recipients.join(', ');
            
            return {
                id: item.id || '',
                type: type,
                field: '',
                definition: url,
                notifyTo: notifyTo
            };
        });
    }

    componentWillUnmount() {
        // Clean up references
        if (this.props.onRef) {
            this.props.onRef(null);
        }
    }

    render() {
        return (
            <React.Fragment>
                <style>{styles}</style>
                <CustomModal 
                    isTheModalOpen={this.state.isTheModalOpen} 
                    modalToggle={this.modalToggle}
                    title={`Alertas y Notificaciones - ${this.props.downloadSource ? this.props.downloadSource.description : ''}`}
                    footerButtons={this.getFooterButtons()}
                    size="lg">
                    <Row>
                        <Col xs="12">
                            {this.state.loading ? (
                                <div className="text-center py-4">
                                    <i className="fa fa-spinner fa-spin mr-2"></i>
                                    Cargando alertas configuradas...
                                </div>
                            ) : this.state.error ? (
                                <div className="text-center text-danger py-4">
                                    <i className="fa fa-exclamation-circle mr-2"></i>
                                    {this.state.error}
                                </div>
                            ) : (
                                <Table responsive striped size="sm" style={{ fontSize: '0.85rem' }}>
                                    <thead>
                                        <tr>
                                            <th>Tipo</th>
                                            <th style={{ width: '40%' }}>Definición</th>
                                            <th>Notificar a</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.alertsList.length === 0 ? (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    No hay alertas configuradas
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.alertsList.map(alert => (
                                                <tr 
                                                    key={alert.id}
                                                    onClick={() => this.selectAlert(alert)}
                                                    style={{ cursor: 'pointer' }}
                                                    className="hover-row"
                                                >
                                                    <td>{alert.type}</td>
                                                    <td style={{ 
                                                        maxWidth: 0,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    }}>
                                                        {alert.definition}
                                                    </td>
                                                    <td>
                                                        {alert.notifyTo ? alert.notifyTo.split(',').map((email, index) => (
                                                            <Badge key={index} color="info" className="mr-1 mb-1">
                                                                {email.trim()}
                                                            </Badge>
                                                        )) : <span className="text-muted">No hay destinatarios</span>}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            )}
                        </Col>
                    </Row>
                    
                    {this.state.selectedAlert && (
                        <Row>
                            <Col xs="12">
                                <Card className="p-3 mt-3 mb-3" style={{ backgroundColor: "#f5f3ef" }}>
                                    <h5>Editar alerta: {this.state.selectedAlert.type}</h5>
                                    <Row className="mt-3">
                                        <Col xs="3">Tipo:</Col>
                                        <Col xs="9">{this.state.selectedAlert.type}</Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col xs="3">Definición:</Col>
                                        <Col xs="9">
                                            {this.isValidUrl(this.state.selectedAlert.definition) ? (
                                                <a 
                                                    href={this.state.selectedAlert.definition}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {this.state.selectedAlert.definition}
                                                </a>
                                            ) : (
                                                this.state.selectedAlert.definition
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col xs="3">Notificar a:</Col>
                                        <Col xs="9">
                                            <div className="mb-2">
                                                {this.state.editedEmails.split(',').map((email, index) => (
                                                    <Badge key={index} color="info" className="mr-1 mb-1">
                                                        {email.trim()}
                                                        <i 
                                                            className="fa fa-times ml-1" 
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.removeEmail(index)}
                                                        />
                                                    </Badge>
                                                ))}
                                            </div>
                                            <Input 
                                                type="text" 
                                                value={this.state.newEmail}
                                                onChange={this.handleNewEmailChange}
                                                onKeyPress={this.handleEmailKeyPress}
                                                placeholder="Ingrese email y presione Enter"
                                            />
                                            <small className="text-muted">Presione Enter para agregar cada email</small>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </CustomModal>
            </React.Fragment>
        );
    }

    // Methods
    modalToggle = () => {
        const newModalState = !this.state.isTheModalOpen;
        
        // If opening the modal, fetch the alerts data
        if (newModalState) {
            this.fetchResourcesData();
        }
        
        this.setState({ isTheModalOpen: newModalState });
    }

    selectAlert = (alert) => {
        this.setState({ 
            selectedAlert: alert,
            editedEmails: alert.notifyTo,
            newEmail: ''
        });
    }

    handleNewEmailChange = (e) => {
        this.setState({ newEmail: e.target.value });
    }

    handleEmailKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const email = this.state.newEmail.trim();
            if (email && email.includes('@')) {
                const currentEmails = this.state.editedEmails ? this.state.editedEmails.split(',').map(e => e.trim()) : [];
                if (!currentEmails.includes(email)) {
                    const newEmails = [...currentEmails, email].join(', ');
                    this.setState({
                        editedEmails: newEmails,
                        newEmail: ''
                    });
                }
            }
        }
    }

    removeEmail = (index) => {
        const emails = this.state.editedEmails.split(',').map(e => e.trim());
        emails.splice(index, 1);
        this.setState({ editedEmails: emails.join(', ') });
    }

    saveChanges = () => {
        if (!this.state.selectedAlert) return;
        
        // Update the alert in the list
        const updatedAlerts = this.state.alertsList.map(alert => {
            if (alert.id === this.state.selectedAlert.id) {
                return {
                    ...alert,
                    notifyTo: this.state.editedEmails
                };
            }
            return alert;
        });
        
        this.setState({
            alertsList: updatedAlerts,
            selectedAlert: null
        });
    }

    getFooterButtons = () => {
        const buttons = [];
        
        if (this.state.selectedAlert) {
            buttons.push(
                <Button 
                    color="success" 
                    key="save-button" 
                    onClick={this.saveChanges}>
                    Guardar
                </Button>
            );
            
            buttons.push(
                <Button 
                    color="danger" 
                    key="cancel-button" 
                    onClick={() => this.setState({ selectedAlert: null })}>
                    Cancelar
                </Button>
            );
        }
        
        return buttons;
    }

    isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser
    };
};

export default connect(mapStateToProps)(AlertsNotificationsModal);